import axios from 'axios'

export const getCompareHeppers = () => {
  return axios.get('helpers/compares')
}

export const getCompareFeeHeppers = () => {
  return axios.get('helpers/compare-fees')
}

export const getCrossCheck = (id, params) => {
  let remoteUrl = 'cross-checks/' + id + '?include=finance'
  return axios.get(remoteUrl, { params: params })
}

export const createCrossCheck = (data) => {
  let remoteUrl = 'cross-checks'
  return axios.post(remoteUrl, data)
}

export const updateCompare = (id, data) => {
  return axios.put('compares/' + id, data)
}

export const ApplyCrossCheck = (id) => {
  let remoteUrl = 'cross-checks/' + id + '/confirm'
  return axios.put(remoteUrl)
}

export const UpdateCrossCheck = (id, data) => {
  let remoteUrl = 'cross-checks/' + id
  return axios.put(remoteUrl, data)
}

export const DeleteCrossCheck = (id) => {
  let remoteUrl = 'cross-checks/' + id
  return axios.delete(remoteUrl)
}

export const exportExcel = (params) => {
  let remoteUrl = 'compares/export-excel'
  return axios.get(remoteUrl, { params: params })
}

export const deleteCompare = (id) => {
  let remoteUrl = 'compares/' + id
  return axios.delete(remoteUrl)
}

export const updateCrossCheck = (id, data) => {
  return axios.post('cross-checks/update/' + id, data)
}

export const removeErrorShipment = (id, data) => {
  return axios.post('cross-checks/' + id + '/remove-error-shipment', data)
}

export const resyncingCode = (id, data) => {
  return axios.post('cross-checks/' + id + '/resync', data)
}

export const updateWeight = (id, data) => {
  return axios.post('cross-checks/' + id + '/update-weight', data)
}

export const verifyCrossCheck = (id, data) => {
  return axios.post('cross-checks/' + id + '/verify', data)
}

export const updateFeeByCarrier = (id, params) => {
  return axios.post('cross-checks/' + id + '/update-fee-by-carrier', null, { params: params })
}

export const updateCrossCheckFee = (id, data) => {
  return axios.post('cross-checks/' + id + '/compare-fee', data)
}

export const updateCrossCheckFee1 = (id, data) => {
  return axios.post('cross-checks/' + id + '/compare-fee-1', data)
}

export const updateCompareFee = (id, data) => {
  return axios.put('compare-fees/' + id, data)
}

export const deleteCompareFee = (id) => {
  let remoteUrl = 'compare-fees/' + id
  return axios.delete(remoteUrl)
}

export const exportExcelFee = (params) => {
  let remoteUrl = 'compare-fees/export-excel'
  return axios.get(remoteUrl, { params: params })
}



// WEBPACK FOOTER //
// ./src/api/compares.js